module.exports = __webpack_public_path__ + "img/table-add-user-icon.09332fb6.svg";